import BackButton from "components/Button/BackButton"
import DeleteButton from "components/Button/DeleteButton"
import SaveButton from "components/Button/SaveButton"
import DatePicker from "components/Input/DatePicker"
import Dropdown from "components/Input/Dropdown"
import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { ApiResponseStatusUnauthorized, ApiResponseSuccess, DateNullDefault, DepositReceived, EmptyString, FormTypeAdd, FormTypeEdit, GuidDefault } from "utils/Constant"
import { ApiGetBookingById, ApiGetBookingRoom, ApiGetBookingTenant, ApiGetPaymentHistory, ApiGetSystemSettingById, ApiInsertBooking, ApiUpdateBooking } from "utils/constants/api"
import useFetch from "utils/hooks/useFetch"
import FailModal from "components/modal/FailModal";
import LoadingModal from "components/modal/LoadingModal";
import SuccessModal from "components/modal/SuccessModal";
import ConfirmationModal from "components/modal/ConfirmationModal";
import moment from "moment"
import { money } from "utils/helpers"
import CompleteButton from "components/Button/CompleteButton"

export default function EDCForm(){
    const navigate = useNavigate()

    const { fetch: insertBooking } = useFetch(ApiInsertBooking)
    const { fetch: updateBooking } = useFetch(ApiUpdateBooking)
    const { fetch: getBookingById } = useFetch(ApiGetBookingById)
    const { fetch: getSystemSetting } = useFetch(ApiGetSystemSettingById)
    const { fetch: getBookingTenant } = useFetch(ApiGetBookingTenant)
    const { fetch: getBookingRoom } = useFetch(ApiGetBookingRoom)
    const { fetch: getPaymentHistory } = useFetch(ApiGetPaymentHistory)

    let queryString = new URLSearchParams(window.location.search)
    let formType = queryString.get("formType")
    let paramBookingId = queryString.get("bookingId")

    // Modal
    const [failModal, setFailModal] = useState({ isOpen: false, data: {}, message: EmptyString })
    const [loading, setLoading] = useState(false)
    const [successModal, setSuccessModal] = useState({ isOpen: false, data: {} })
    const [confirmationModal, setConfirmationModal] = useState({ isOpen: false, data: {} })

    const [bankCode, setBankCode] = useState(EmptyString)
    const [bankName, setBankName] = useState(EmptyString)
    const [callCenter, setCallCenter] = useState(EmptyString)

    const [paymentHistory, setPaymentHistory] = useState([])
    const [bookingCode, setBookingCode] = useState(EmptyString)
    const [bookingDate, setBookingDate] = useState(EmptyString)
    const [bookingType, setBookingType] = useState(EmptyString)
    const [roomId, setRoomId] = useState(EmptyString)
    const [tenantId, setTenantId] = useState(EmptyString)
    const [checkInDate, setCheckInDate] = useState(EmptyString)
    const [checkOutDate, setCheckOutDate] = useState(EmptyString)
    const [deposit, setDeposit] = useState(EmptyString)
    const [createDate, setCreateDate] = useState(EmptyString)
    const [status, setStatus] = useState(EmptyString)
    const [updateDate, setUpdateDate] = useState(EmptyString)
    const [updateBy, setUpdateBy] = useState(EmptyString)

    const [deleteBtnVisible, setDeleteBtnVisible] = useState(true)
    const [tenantOptionDisabled, setTenantOptionDisabled] = useState(false)
    const [bookingDateDisabled, setBookingDateDisabled] = useState(false)
    const [checkInDateDisabled, setCheckInDateDisabled] = useState(false)

    // Dropdown options
    const [tenantOptions, setTenantOptions] = useState([])
    const [roomOptions, setRoomOptions] = useState([])
    const [bookingTypeOptions, setBookingTypeOptions] = useState([])

    // Error
    const [errorTenantId, setErrorTenantId] = useState(false)
    const [errorTenantName, setErrorTenantName] = useState(false)
    const [errorPlaceOfBirth, setErrorPlaceOfBirth] = useState(false)
    const [errorDateOfBirth, setErrorDateOfBirth] = useState(false)

    const [bookingCodeDisabled, setSetBookingCodeDisabled] = useState(true)

    useEffect(() => {
        // setLoading(true)

        // fGetBookingTenant().then(() => {
        //     fGetBookingType()
        // }).then(() => {
        //     if (formType === FormTypeEdit){
        //         fGetBookingById().then((res) => {
        //             fGetBookingRoom(res[0], res[2], res[1]).then(() => {
        //                 setRoomId(res[1])
        //                 fGetPaymentHistory(paramBookingId)  
        //             })                          
        //         })                
        //         setTenantOptionDisabled(true)
        //         setBookingDateDisabled(true)
        //     }else{
        //         setDeleteBtnVisible(false)
        //         setBookingDate(new Date())
        //     }     
        // }).then(() => {
             
        // }).finally(() => {
        //     setLoading(false)
        // })
    }, [])

    function fSaveBtnClick(){
        setConfirmationModal({ isOpen: true, data: { onSuccess: async () => { 
            setConfirmationModal({ isOpen: false })
            if (formType === FormTypeAdd){
                fInsertBooking()
            }else{
                fUpdateBooking()
            }
        }}})
    }
    function fDeleteBtnClick(){
        setConfirmationModal({ isOpen: true, data: { onSuccess: async () => { 
            setConfirmationModal({ isOpen: false })
            //fDeleteTenant()
        }}})
    }

    // Function Api Call
    function fInsertBooking(){
        setLoading(true)
        console.log(checkOutDate)
        insertBooking({
            data:{
                kostId: localStorage.getItem("KostId"),
                kostCode: localStorage.getItem("KostCode"), 
                bookingDate: moment(bookingDate).format("yyyy-MM-DD"),
                bookingType: bookingType,
                roomId: roomId,
                tenantId: tenantId,
                checkInDate: moment(checkInDate).format("yyyy-MM-DD"),
                checkOutDate: checkOutDate === "" || checkOutDate === null ? null : moment(checkOutDate).format("yyyy-MM-DD"),
                updateId: localStorage.getItem("Id")
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                setSuccessModal({ isOpen: true, data: { onSuccess: async () => { navigate("/kost/booking") }} })
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        }).finally(() => {
            setLoading(false)
        })
    }
    function fUpdateBooking(){
        setLoading(true)

        updateBooking({
            data:{
                kostId: localStorage.getItem("KostId"),
                bookingId: paramBookingId,
                checkInDate: moment(checkInDate).format("yyyy-MM-DD"),
                checkOutDate: checkOutDate === "" ? null : moment(checkOutDate).format("yyyy-MM-DD"),
                roomId: roomId,
                updateId: localStorage.getItem("Id")
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                setSuccessModal({ isOpen: true, data: { onSuccess: async () => { navigate("/kost/booking") }} })
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        }).finally(() => {
            setLoading(false)
        })
    }
    
    async function fGetBookingById(){
        let tempCheckIn = ""
        let tempRoomNum = ""
        let tempRoomId = ""

        await getBookingById({
            data: {
                kostId: localStorage.getItem("KostId"),
                bookingId: paramBookingId
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                let data = response?.data
                setBookingCode(data.bookingCode)
                setBookingDate(data.bookingDate)
                setCheckInDate(data.checkInDate)
                if (data.checkOutDate !== DateNullDefault){
                    setCheckOutDate(data.checkOutDate)
                }

                if (new Date(data.checkInDate) <= new Date()){
                    setCheckInDateDisabled(true)
                }
                setBookingType(data.bookingType)                
                //setRoomId(data.roomId)
                //setRoomNumber(data.roomNumber)
                setTenantId({ label: data.tenantName, value: data.tenantId })
                setDeposit(data.deposit)
                setCreateDate(moment(data.createDate).format("DD MMM yyyy"))
                setUpdateDate(moment(data.updateDate).format("DD MMM yyyy"))
                setUpdateBy(data.updateBy)
                setStatus(data.bookingStatus)

                if (data?.status === "Delete"){
                    setDeleteBtnVisible(false)
                }

                tempCheckIn = data.checkInDate
                tempRoomId = data.roomId
                tempRoomNum = data.roomNumber
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })

        return [tempCheckIn, tempRoomId, tempRoomNum]
    }

    async function fGetBookingTenant(){
        await getBookingTenant({
            data: {
                kostId: localStorage.getItem("KostId")
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                let data = response.data
                let tempArray = []

                for (let i = 0; i < data.length; i++){
                    tempArray.push({ label: data[i].name, value: data[i].tenantId })
                }
                
                setTenantOptions(tempArray)
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }
    async function fGetBookingRoom(checkInDate, roomNumber, roomId){
        await getBookingRoom({
            data: {
                kostId: localStorage.getItem("KostId"),
                checkInDate: moment(checkInDate).format("yyyy-MM-DD")
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                let data = response.data
                let tempArray = []

                if (roomNumber !== null && roomId !== null){
                    tempArray.push({ label: roomNumber, value: roomId })
                }

                for (let i = 0; i < data.length; i++){
                    tempArray.push({ label: data[i].roomNumber, value: data[i].roomId })
                }

                setRoomOptions(tempArray)
                //setrrom(tempArray[0])
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }

    // Function


    return (
        <div className="flex flex-col gap-2">
            <div>
                <span className="font-semibold text-2xl">EDC - { formType }</span>
            </div>
            <hr />

            <div className="mt-5 flex flex-col gap-3">
                {/* Bank Code */}
                <div>
                    <div className="flex">
                        <div className="flex flex-col sm:flex-row sm:items-center w-full">
                            <div className="w-48">
                                <span>Bank Code</span>
                            </div>
                            <div className="px-4 hidden sm:block">
                                <span>:</span>
                            </div>
                            <div className="w-full sm:w-72">
                                <input className="input" value={ bankCode } onChange={(e) => { setBankCode(e.target.value) }} disabled={ formType === FormTypeAdd ? false : true } />
                            </div>
                        </div>
                    </div>
                    <div className={`flex items-center ${ errorTenantId ? 'block' : 'hidden' }`}>
                        <div className="w-48" />
                        <div className="w-9" />
                        <span className="text-red-500">Bank Code is required!</span>
                    </div>
                </div>

                {/* Bank Name */}
                <div>
                    <div className="flex">
                        <div className="flex flex-col sm:flex-row sm:items-center w-full">
                            <div className="w-48">
                                <span>Bank Name</span>
                            </div>
                            <div className="px-4 hidden sm:block">
                                <span>:</span>
                            </div>
                            <div className="w-full sm:w-72">
                                <input className="input" value={ bankName } onChange={(e) => { setBankName(e.target.value) }} />
                            </div>
                        </div>
                    </div>
                    <div className={`flex items-center ${ errorTenantId ? 'block' : 'hidden' }`}>
                        <div className="w-48" />
                        <div className="w-9" />
                        <span className="text-red-500">Bank Name is required!</span>
                    </div>
                </div>

                {/* Call Center */}
                <div>
                    <div className="flex">
                        <div className="flex flex-col sm:flex-row sm:items-center w-full">
                            <div className="w-48">
                                <span>Call Center</span>
                            </div>
                            <div className="px-4 hidden sm:block">
                                <span>:</span>
                            </div>
                            <div className="w-full sm:w-72">
                                <input className="input" value={ callCenter } onChange={(e) => { setCallCenter(e.target.value) }} />
                            </div>
                        </div>
                    </div>
                    <div className={`flex items-center ${ errorTenantId ? 'block' : 'hidden' }`}>
                        <div className="w-48" />
                        <div className="w-9" />
                        <span className="text-red-500">Call Center is required!</span>
                    </div>
                </div>

            </div>
                

            <div className="mt-5 flex flex-wrap justify-end w-full gap-2">
                <SaveButton onClick={() => { fSaveBtnClick() }} visible={true} />
                <DeleteButton visible={ formType === FormTypeAdd ? false : true } onClick={() => { fDeleteBtnClick() }} />
                <BackButton onClick={() => { navigate("/bank") }}  />
            </div>

             {/* Modal */}
 			{failModal.isOpen && ( <FailModal onClose={() => setFailModal({ isOpen: false, data: {}, message: EmptyString })} data={failModal?.data} message={failModal?.message} /> )}
 			{loading ? (<LoadingModal />) : (<div />)}
            {successModal.isOpen && ( <SuccessModal onClose={() => setSuccessModal({ isOpen: false, data: {} })} data={successModal?.data} /> )}
            {confirmationModal.isOpen && ( <ConfirmationModal onClose={() => setConfirmationModal({ isOpen: false, data: {} })} data={confirmationModal?.data} /> )}
        </div>
    )
}